<template>
  <div v-if="offer">
    <Details :offer="offer" @updated="offerUpdated" />
    <FeeRanges :feeConfiguration="offer" :url="url" />
    <offer-associations :offer="offer" />
  </div>
</template>
<script>
import Details from "./details.vue";
import FeeRanges from "../../generalLayouts/feeRanges/Index.vue";
import offerAssociations from "./OfferAssociations.vue";
export default {
  components: {
    Details,
    FeeRanges,
    offerAssociations,
  },
  props: {
    id: {
      required: true,
    },
    feeConfigurationId: {
      required: true,
    },
  },
  data() {
    return {
      offer: undefined,
    };
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    url() {
      return `api/v1/transactions/offerConfig/${this.offer.id}/fees`;
    },
  },
  methods: {
    async fetchData() {
      await this.$http
        .get(`api/v1/transactions/feeConfigurations/${this.feeConfigurationId}/offer/${this.id}`)
        .then((data) => {
          this.offer = data;
        });
    },
    async offerUpdated({ message }) {
      this.isEditing = false;
      Notify.success(message);
      this.fetchData();
    },
  },
};
</script>
